import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../common/http/http-utils';
@Injectable()
export class NetworkService {

    value = '';

    constructor(public http: HttpClient) {
    }

    getAllNetworks() {
        return this.http.get(HttpUtils.getBaseUrl() + '/hybridity/api/networks')
            ;
    }

    getAllGateways() {
        return this.http.get(HttpUtils.getBaseUrl() + '/hybridity/api/gateways')
            ;
    }

    getIpUsage(networkId: string) {
        return this.http.get(HttpUtils.getBaseUrl() + '/hybridity/api/networks/' + networkId + '/ipCount')
            ;
    }

    getDirectConnectList() {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/hybridity/api/vcd/networks/inventory/query?entityType=directConnect')
            ;
    }

    getVDCNetworkList() {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/hybridity/api/vdcNetworks')
            ;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vcd/networking-vcd.service.ts